import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateCarSlug(car: any): string {
  const parts = [
    car.year,
    car.make,
    car.model,
    car.district || car.location,
    car.id
  ].filter(Boolean);
  return parts.join('-').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
}
